/** Messages in DMs and groups are removed after 24 hours (unless pinned). */
export const EPHEMERAL_MESSAGE_TTL_MS = 24 * 60 * 60 * 1000;

export type EphemeralMessage = { createdAt: Date; pinned?: boolean };

export function isEphemeralChannel(channel: { type: string }): boolean {
  return channel.type === "DirectMessage" || channel.type === "Group";
}

export function isExpiringMessage(message: { pinned?: boolean }): boolean {
  return !message.pinned;
}

export function getMessageExpiresAt(message: EphemeralMessage): Date {
  return new Date(message.createdAt.getTime() + EPHEMERAL_MESSAGE_TTL_MS);
}

export function isMessageExpired(
  message: EphemeralMessage,
  now = Date.now(),
): boolean {
  if (message.pinned) return false;
  return getMessageExpiresAt(message).getTime() <= now;
}

export function getMsUntilExpiry(
  message: EphemeralMessage,
  now = Date.now(),
): number {
  if (message.pinned) return Number.POSITIVE_INFINITY;
  return Math.max(0, getMessageExpiresAt(message).getTime() - now);
}
